import React, { useState } from 'react';
import {
  Button,
  Container,
  TextField,
  Table,
  Modal,
  Tooltip,
  TableBody,
  TableCell,
  Box,
  Typography,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
  Stack,
  styled,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  IconButton,
  useTheme,
} from '@mui/material';
import  InfoOutlineIcon  from '@mui/icons-material/InfoOutlined';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  Close as CloseIcon,
  Search as SearchIcon,
  KeyboardDoubleArrowLeft as ChevronLeft,
  KeyboardDoubleArrowRight as ChevronRight,
} from '@mui/icons-material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SalaryHeadType = () => {
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 20, 30];
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showUserGuideModal,setShowUserGuideModal]=useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('');

const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [searchTerm, setSearchTerm] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddSalaryHeadTypeModal, setShowAddSalaryHeadTypeModal] = useState(false);
  const [showEditSalaryHeadTypeModal, setShowEditSalaryHeadTypeModal] = useState(false);
  const [selectedSalaryHeadType, setSelectedSalaryHeadType] = useState({ salaryHeadTypeId: null, salaryHeadTypeName: '' });
  const [salaryHeadTypeName, setSalaryHeadTypeName] = useState('');

  // Static data for salary head types
  const staticSalaryHeadTypeData = [
    { salaryHeadTypeId: 1, salaryHeadTypeName: 'Basic Salary' },
    { salaryHeadTypeId: 2, salaryHeadTypeName: 'Allowances' },
    { salaryHeadTypeId: 3, salaryHeadTypeName: 'Bonuses' },
    { salaryHeadTypeId: 4, salaryHeadTypeName: 'Deductions' },
    { salaryHeadTypeId: 5, salaryHeadTypeName: 'Overtime Pay' },
    { salaryHeadTypeId: 6, salaryHeadTypeName: 'Taxes' },
  ];

  const handleEdit = (salaryHeadType) => {
    setSelectedSalaryHeadType(salaryHeadType);
    setSalaryHeadTypeName(salaryHeadType.salaryHeadTypeName);
    setShowEditSalaryHeadTypeModal(true);
  };

  const handleDelete = (salaryHeadType) => {
    setSelectedSalaryHeadType(salaryHeadType);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedSalaryHeadType({ salaryHeadTypeId: null, salaryHeadTypeName: '' });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = Number(event.target.value);
    setRowsPerPage(newRowsPerPage);
    setPage(1);
  };

  const handleAddSalaryHeadType = () => {
    setSalaryHeadTypeName('');
    setShowAddSalaryHeadTypeModal(true);
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (salaryHeadTypeName) {
      setSnackbarMessage('Salary Head Type Added Successfully');
      setOpenSnackbar(true);
      setSnackbarSeverity('success')
      setShowAddSalaryHeadTypeModal(false);
      setSalaryHeadTypeName('');
    } else {
      setSnackbarMessage('plz fill rquired field!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error");
    }
  };

  const handleUpdate = () => {
    if (salaryHeadTypeName) {
      setSnackbarMessage('Salary Head Type Updated Successfully');
      setOpenSnackbar(true);
      setSnackbarSeverity('success')
      setShowEditSalaryHeadTypeModal(false);
      setSalaryHeadTypeName('');
    } else {
      setSnackbarMessage('plz fill rquired field!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error");
    }
  };

  const handleReset = () => {
    setSalaryHeadTypeName('');
  };

  const handleCancel = () => {
    setShowEditSalaryHeadTypeModal(false);
    setSalaryHeadTypeName('');
  };

  const filteredData = staticSalaryHeadTypeData.filter((salaryHeadType) =>
    salaryHeadType.salaryHeadTypeName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container maxWidth={false} sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent:'space-between',
          mb: 1,
          p: 2,
          boxShadow: 'none',
          maxWidth: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{display:'flex',justifyContent:'center',alignItems:'center',gap:2}}>
        <TextField
                                   variant="outlined"
                                   placeholder="Search..."
                                   value={searchTerm}
                                   onChange={(e) => setSearchTerm(e.target.value)}
                                   InputProps={{
                                     startAdornment: (
                                       <InputAdornment position="start">
                                         <SearchIcon
                                           sx={{
                                             color: theme.palette.primary.main,
                                             marginLeft: 1.5,
                                             fontSize: 24,
                                           }}
                                         />
                                       </InputAdornment>
                                     ),
                                     endAdornment: searchTerm && (
                                       <InputAdornment position="end">
                                         <IconButton
                                           size="small"
                                           onClick={() => setSearchTerm('')}
                                           sx={{
                                             color: "grey",
                                             marginRight: 1,
                                           }}
                                         >
                                           <CloseIcon fontSize="small" />
                                         </IconButton>
                                       </InputAdornment>
                                     ),
                                     sx: {
                                       borderRadius: '30px',
                                       backgroundColor: theme.palette.mode === 'dark'
                                         ? 'rgba(255, 255, 255, 0.15)'
                                         : 'rgba(255, 255, 255, 1)',
                                       boxShadow: theme.palette.mode === 'dark'
                                         ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                                         : '0 2px 8px rgba(0, 0, 0, 0.1)',
                                       '& .MuiOutlinedInput-notchedOutline': {
                                         border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                                       },
                                       '&:hover': {
                                         backgroundColor: theme.palette.mode === 'dark'
                                           ? 'rgba(255, 255, 255, 0.2)'
                                           : 'rgba(240, 240, 240, 1)',
                                         boxShadow: theme.palette.mode === 'dark'
                                           ? '0 2px 12px rgba(0, 0, 0, 0.4)'
                                           : '0 2px 12px rgba(0, 0, 0, 0.15)',
                                       },
                                       '&.Mui-focused': {
                                         backgroundColor: theme.palette.mode === 'dark'
                                           ? 'rgba(255, 255, 255, 0.25)'
                                           : 'rgba(255, 255, 255, 1)',
                                         boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
                                         '& .MuiOutlinedInput-notchedOutline': {
                                           border: `2px solid ${theme.palette.primary.main}`,
                                         },
                                       },
                                       paddingLeft: 1.5,
                                       height: '50px',
                                       transition: 'all 0.3s ease',
                                     },
                                   }}
                                   sx={{
                                     width: 350,
                                     maxWidth: '100%',
                                     '& .MuiInputBase-input': {
                                       padding: '10px 14px',
                                       color: theme.palette.text.primary,
                                       fontWeight: 500,
                                     },
                                   }}
                                 />
        <Button
          variant="contained"
          onClick={handleAddSalaryHeadType}
          sx={{
            ml: 2,
            width: "100px",
            height: "50px",
            borderRadius:'10px',
            padding: "10px 0",
            fontWeight: 'bold',
            backgroundColor: theme.palette.primary.main,
            '&:hover': { backgroundColor: theme.palette.primary.dark },
          }}
          startIcon={<AddIcon />}
        >
          ADD
        </Button>
        </Box>
         <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <IconButton
                    onClick={() => setShowUserGuideModal(true)}
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: '50%',
                      minWidth: 0, // Remove MUI's default padding
                    }}
                  >
                    <InfoOutlineIcon sx={{ fontSize: 30 }} />
                  </IconButton>
                </Box>
      </Box>
      <Paper
        elevation={3}
        sx={{
          paddingBottom: 0,
          maxWidth: '100%',
          boxSizing: 'border-box',
          mx: 'auto',
          backgroundColor: theme.palette.background.paper,
          borderRadius: '16px',
        }}
      >
        <CustomTableScrollbar sx={{ width: '100%', overflowX: 'auto' }}>
          <TableContainer sx={{ width: '100%', borderRadius: '16px' }}>
            <Table
              sx={{
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: theme.palette.primary.main,
                  color: 'white',
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 70 }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 180 }}>Salary Head</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: theme.palette.primary.dark, fontSize: '1.1rem' }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((salaryHeadType, index) => (
                    <TableRow
                      key={salaryHeadType.salaryHeadTypeId}
                      sx={{
                        backgroundColor: index % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                      }}
                    >
                      <TableCell sx={{ fontSize: '1rem' }}>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{salaryHeadType.salaryHeadTypeName}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          onClick={() => handleEdit(salaryHeadType)}
                          sx={{
                            color: theme.palette.primary.light,
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => handleDelete(salaryHeadType)}
                          sx={{
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow sx={{
                backgroundColor: theme.palette.background.paper,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}>
                    <TableCell colSpan={3} align="center" sx={{ fontSize: '1rem', padding: '20px', wordSpacing: 7 }}>
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTableScrollbar>
      </Paper>
      {filteredData.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography variant="body2" color={theme.palette.primary.main}>
            Page <strong>{page}</strong> of <strong>{Math.ceil(filteredData.length / rowsPerPage)}</strong>
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(filteredData.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>Rows</InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {rowsPerPageOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Box>
      )}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Modal
        open={showDeleteModal}
        onClose={handleCloseDeleteModal}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation ⚠️
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete {selectedSalaryHeadType.salaryHeadTypeName}?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleCloseDeleteModal} variant="outlined" sx={{ mr: 1 }} data-app-cancel="true">
                Cancel
              </Button>
              <Button variant="contained" color="error" onClick={handleCloseDeleteModal}>
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={showAddSalaryHeadTypeModal}
        onClose={() => setShowAddSalaryHeadTypeModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Add Salary Head Type
            </Typography>
            <IconButton
              onClick={() => setShowAddSalaryHeadTypeModal(false)}
              sx={{ color: '#fff' }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <TextField
              label="Salary Head Type Name"
              variant="outlined"
              fullWidth
              value={salaryHeadTypeName}
              onChange={(e) => setSalaryHeadTypeName(e.target.value)}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip title={!salaryHeadTypeName ? "Enter Salary Head Type Name" : ""} arrow>
                <span>
                  <Button
                    variant="contained"
                    onClick={handleSave}
                    sx={{
                      mr: 2,
                      backgroundColor: theme.palette.primary.main,
                      '&:hover activaColor': theme.palette.primary.dark,
                    }}
                    disabled={!salaryHeadTypeName}
                  >
                    SAVE
                  </Button>
                </span>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleReset}
              >
                RESET
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={showEditSalaryHeadTypeModal}
        onClose={handleCancel}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Edit Salary Head Type
            </Typography>
            <IconButton onClick={handleCancel} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <TextField
              label="Salary Head Type Name"
              variant="outlined"
              fullWidth
              value={salaryHeadTypeName}
              onChange={(e) => setSalaryHeadTypeName(e.target.value)}
              sx={{
                mb: 3,
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
              }}
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip title={!salaryHeadTypeName ? "Enter Salary Head Type Name" : ""} arrow>
                <span>
                  <Button
                    variant="contained"
                    onClick={handleUpdate}
                    sx={{
                      mr: 2,
                      backgroundColor: theme.palette.primary.main,
                      '&:hover': { backgroundColor: theme.palette.primary.dark },
                    }}
                    disabled={!salaryHeadTypeName}
                  >
                    UPDATE
                  </Button>
                </span>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={showUserGuideModal}
        onClose={() => setShowUserGuideModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 800,
            bgcolor: 'background.paper',
            borderRadius: '16px',
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Salary Head Type Management - User Guide
            </Typography>
            <IconButton
              onClick={() => setShowUserGuideModal(false)}
              sx={{ color: '#fff', position: 'absolute', right: 14 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Scrollable Content */}
          <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
  {/* Section 1: Add Salary Head Type */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
  >
    ➤ Follow these steps to add a new salary head type:
  </Typography>
  <ul
    style={{
      marginLeft: '20px',
      lineHeight: '1.8',
      cursor: 'pointer',
    }}
  >
    <li>
      Click the <strong>"ADD"</strong> button at the top right to open the Add Salary Head Type modal.
    </li>
    <li>
      Enter the <strong>Salary Head Type Name</strong> in the provided text field.
    </li>
    <li>
      Before clicking the <strong>"SAVE"</strong> button, review the entered information to ensure accuracy.
    </li>
    <li>
      Click the <strong>"SAVE"</strong> button to add the salary head type. A success message will be displayed via snackbar.
    </li>
    <li>
      The newly added salary head type will appear in the <strong>Salary Head Type List</strong> table.
    </li>
    <li>
      To reset the form, click the <strong>"RESET"</strong> button to clear the field and close the modal.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Salary Head Type Name is a mandatory field. The SAVE button remains disabled until this field is filled.
  </Typography>

  {/* Section 2: Edit Salary Head Type */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to update an existing salary head type:
  </Typography>
  <ul
    style={{
      marginLeft: '20px',
      lineHeight: '1.8',
      cursor: 'pointer',
    }}
  >
    <li>
      Select the salary head type record you want to edit from the <strong>Salary Head Type List</strong> table.
    </li>
    <li>
      Click the <strong>Edit</strong> icon (pencil) in the Action column to open the Edit Salary Head Type modal.
    </li>
    <li>
      Update the <strong>Salary Head Type Name</strong> as required.
    </li>
    <li>
      Before clicking the <strong>"UPDATE"</strong> button, ensure the required field is filled.
    </li>
    <li>
      Click the <strong>"UPDATE"</strong> button to save the changes. A success message will be displayed via snackbar.
    </li>
    <li>
      To discard changes, click the <strong>"CANCEL"</strong> button to close the modal.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Salary Head Type Name is mandatory. The UPDATE button remains disabled until this field is filled.
  </Typography>

  {/* Section 3: Delete Salary Head Type */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to delete a salary head type:
  </Typography>
  <ul
    style={{
      marginLeft: '20px',
      lineHeight: '1.8',
      cursor: 'pointer',
    }}
  >
    <li>
      Select the salary head type record you want to delete from the <strong>Salary Head Type List</strong> table.
    </li>
    <li>
      Click the <strong>Delete</strong> icon (trash) in the Action column.
    </li>
    <li>
      Confirm the deletion by clicking <strong>"Yes, Delete"</strong> in the confirmation modal.
    </li>
    <li>
      The salary head type will be removed from the list, and a confirmation message will be displayed.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Deleted salary head types cannot be recovered. Please proceed with caution.
  </Typography>

  {/* Section 4: Search Salary Head Types */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to search for a salary head type:
  </Typography>
  <ul
    style={{
      marginLeft: '20px',
      lineHeight: '1.8',
      cursor: 'pointer',
    }}
  >
    <li>
      Use the search bar located at the top-left of the <strong>Salary Head Type List</strong>.
    </li>
    <li>
      Enter the <strong>Salary Head Type Name</strong> (or part of it) to filter the records.
    </li>
    <li>
      The table will automatically update to display matching salary head types.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: The search is case-insensitive and filters by Salary Head Type Name.
  </Typography>

  {/* Section 5: Pagination */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to navigate the salary head type list:
  </Typography>
  <ul
    style={{
      marginLeft: '20px',
      lineHeight: '1.8',
      cursor: 'pointer',
    }}
  >
    <li>
      Use the pagination controls at the bottom of the table to browse through salary head types.
    </li>
    <li>
      Click the left (<strong>&lt;</strong>) or right (<strong>&gt;</strong>) arrows to move between pages.
    </li>
    <li>
      Click on a specific page number to navigate directly to that page.
    </li>
    <li>
      Adjust the number of rows per page using the dropdown menu (for example, 5, 10, 20, or 30 rows).
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: The table displays only the selected number of rows per page. If no records match, <strong>"No Data Found"</strong> will be shown.
  </Typography>

  {/* Bottom Close Button */}
  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
    {/* Optional Close button if required */}
  </Box>
</CustomTableScrollbar>

        </Box>
      </Modal>
      <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default SalaryHeadType;